export default "__VITE_ASSET__1f6e83e4__"